import { useEffect } from 'react';
import { redirect } from 'next/navigation';

import { getTreezStores } from '@/utils/treez';

const treezStores = getTreezStores();

const useCheckValidStore = (storeName?: string) => {
  const treezStoreNames = treezStores?.map(({ short_name }) => short_name);

  useEffect(() => {
    const isValidStoreName = treezStoreNames?.includes(storeName ?? '');
    if (storeName && !isValidStoreName) {
      redirect('/kiosk');
    }
  }, [storeName]);
};

export { useCheckValidStore };
